import React from 'react';
import { useTranslation } from 'react-i18next';
import { Rating } from 'react-simple-star-rating';
import { i18nKeys } from '../../utils/i18n.utils';
import { roundFloat } from '../../utils/number.utils';

interface StarRatingProps {
  value: number;
  valueCount?: number;
  showAverage?: 'short' | 'long';
  inlineAverage?: boolean;
  customView?: boolean;
}

const StarRating: React.FC<StarRatingProps> = ({
  value,
  valueCount = 0,
  showAverage = false,
  inlineAverage = false,
  customView = false,
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'inline-block' }}>
      <Rating readonly initialValue={value} size={customView ? 25 : 15} iconsCount={5} allowFraction />
      {showAverage === 'short' && (
        <small style={{ verticalAlign: '1px' }}> &nbsp; {roundFloat(value).toFixed(2)}</small>
      )}
      {showAverage === 'long' && (
        <div className="default-text" style={{ display: inlineAverage ? 'inline-block' : 'block', marginLeft: '5px' }}>
          {t(i18nKeys.general.average)} {roundFloat(value).toFixed(2)}{' '}
          {typeof valueCount === 'number' && `(${valueCount})`}
        </div>
      )}
    </div>
  );
};
export default StarRating;
